FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};

    //  element
    var ELEM = '[data-fd="button"]';
    var eventsWired = false;

    $.widget("custom.button", {
        _delay: false,
        _buttonItem: null,
        _deleteItem: null,

        options: {
            useparent: true,
            parentid: -1,
            type: 'click',  // click, formdelete, rowedit, tabmenu, controlbardelete, lidelete, modaldelete, modalconfirm, toggle, showhide
            callbackprefix: 1,
            tag: 700,
            target: '',             //  used in show/hide
            show: true,             //  used in show/hide
            showonload: false,      //  used in show/hide
            noedit: false,
            stoppropagation: false,
            value: true,
            lockfor: 1000
        },
        _create: function () {
            $.extend(this.options, this.element.data());

            if (!eventsWired) {
                $(document)
                    .on('click', ELEM, this._handleClick)
                    .on('keydown', ELEM, this._handleKeyDown)
                    .on('click', '[data-type=cancel-delete],[data-cancel=true]', this._handleHideDelete)
                    .on('click', '[data-type=confirm-delete],[data-delete=true]', this._handleConfirm);

                eventsWired = true;
            }

            me.setControlItemOptions(this.element, this.options);

            if (this.options.noedit) {
                this.element.attr('disabled', true).css({ cursor: 'default' });
            } else {
                this.element.css({ cursor: 'pointer' });
            }

            if (this.options.showonload) {
                this._setShowHide();
            }

            if (this.options.type == 'toggle') {
                this.element.find('.btn-toggle-indicator').remove();
                if (this.element.find('.fa').length == 0) {
                    this.element.prepend($("<i class='fa fa-fw'>"));
                }
            }

            this.element.addClass("button");
            this.refresh();
        },
        _setOptions: function (options) {
            this._super(options);
            this.element.data(options);
            this.refresh();
        },
        refresh: function () {
            this.element.attr({
                'data-tag': this.options.tag,
                'data-noedit': this.options.noedit
            });
            this.element.attr('disabled', this.options.noedit);
            if (this.options.type == 'toggle') {
                this.element.toggleClass("active btn-success", this.options.value).toggleClass("btn-secondary", !this.options.value);
                this.element.find('i').toggleClass("fa-check-square-o", this.options.value).toggleClass("fa-square-o", !this.options.value);
            }
        },
        attach: function (self) {
            this.element = self;
        },
        _destroy: function () {
        },

        _handleClick: function (event) {
            var self = $(event.target).closest(ELEM).data('customButton');
            if (!self )
                return;

            if (self.options.noedit ||
                $(event.target).closest('a').is("[data-ajax=true]") ||
                self.element.is("[data-ajax=true]") || self.element.attr('disabled') ||
                self.element.is('.locked')) {
                return;
            }

            switch (self.options.type) {
                case 'formdelete':
                    self._setFormDelete(event);
                    break;
                case 'showhide':
                    self._setShowHide(event);
                    break;
                case 'rowedit':
                    self._setRowEdit(event);
                    break;
                case 'tabmenu':
                    self._setTabMenu(event);
                    break;
                case 'controlbardelete':
                    self._setControlBarDelete(event, 'ul');
                    break;
                case 'lidelete':
                    self._setControlBarDelete(event, 'li');
                    break;
                case 'modaldelete':
                    self._setModalConfirm(event, 'delete');
                    break;
                case 'modalconfirm':
                    self._setModalConfirm(event, 'confirm');
                    break;
                case 'toggle':
                    self._setToggle(event);
                    break;
                default:
                    self._setCallback(event);
                    break;
            }

            if (self.options.stoppropagation) {
                event.stopPropagation();
            }
        },
        _handleKeyDown: function (event) {
            if (event.which === 13 || event.keyCode === 13) {
                $(event.target).trigger('click');
            }
        },

        // type=formdelete
        _setFormDelete: function (event) {
            var self = this;
            var parent = this.element.closest("ul");

            if (parent.length === 0) {
                return;
            }

            this._buttonItem = parent.find('[data-row1="true"]');
            this._deleteItem = parent.find('[data-row2="true"]');
            this._delay = false;
            this._buttonItem.addClass('hidden');
            this._deleteItem.css('opacity', 0).removeClass('hidden').animate({ opacity: 1 }, 600);

            if (this._delay) {
                clearTimeout(this._delay);
            }
            this._delay = setTimeout(function () {
                self._hideDelete();
            }, 6000);
        },

        _hideDelete: function () {
            if (!this._delay) {
                return;
            }
            if (this.options.type == 'formdelete') {
                this._deleteItem.addClass('hidden');
            } else {
                this._deleteItem.remove();
            }
            this._buttonItem.css('opacity', 0).removeClass('hidden').animate({ opacity: 1 }, 600);
            this._delay = false;
        },
        _handleHideDelete: function (event) {
            var self = $(event.target).closest('[data-cbhelper=true]').length > 0
                ? $(event.target).closest("[data-cbhelper=true]").data('customButton')
                : ($(event.target).closest(".btn-group").length > 0
                    ? $(event.target).closest(".btn-group").prev(ELEM).data('customButton')
                    : $(event.target).closest('ul').find('[data-type=formdelete]').data('customButton'));
            self._hideDelete();
        },
        _handleConfirm: function () {
            var self = $(event.target).closest('[data-cbhelper=true]').length > 0
                ? $(event.target).closest("[data-cbhelper=true]").data('customButton')
                : ($(event.target).closest(".btn-group").length > 0
                    ? $(event.target).closest(".btn-group").prev(ELEM).data('customButton')
                    : $(event.target).closest('ul').find('[data-type=formdelete]').data('customButton'));
            self._hideDelete();
            self._setCallback();
        },


        //  type=showhide
        _setShowHide: function () {
            if (this.options.target.length === 0) return;

            this.options.target.toggleClass('hidden', this.options.show);
            this.options.show = !this.options.show;
            this.element.data(this.options);

            this.element.button('option', 'show', !this.options.show);
        },

        //  type=rowedit
        _setRowEdit: function (event) {
            var td = this.element.closest('td');
            var table = td.closest('table');

            table.find('tr td:first-child').removeClass('bg-highlight');
            td.addClass('bg-highlight');

            this._setCallback();
        },

        //  type=tabmenu
        _setTabMenu: function (event) {
            var ul = this.element.parents('ul');

            ul.children('li').removeClass('active');
            this.element.parents('li').addClass('active');

            this._setCallback();
        },

        //  type=conrolbardelete|lidelete
        _setControlBarDelete: function (event, target) {
            var self = this;
            var parent = target == 'li' ? this.element.closest(target) : this.element.parents(target).first();
            if (parent.hasClass("hidden")) {
                return;
            }

            this._delay = false;

            if (parent.length === 0) {
                return;
            }

            var gParent = parent.parent();
            var aR = [];
            aR.push(
                "<ul class='list-inline list-unstyled " + (target == 'li' ? this.element.closest(target).attr('class') : "") + "' data-cbhelper='true'>",
                "<li class='pr-2'>",
                "<a class='color-red' data-delete='true'>",
                "<i class='fa fa-trash fa-fw'></i>",
                "</a>",
                "</li>",
                "<li>",
                "<a data-cancel='true'>",
                "<i class='fa fa-ban fa-fw'></i>",
                "</a>",
                "</li>",
                "</ul>"
            );

            parent.addClass('hidden');
            if (target == 'li') {
                parent.after(aR.join(''));
            } else {
                gParent.append(aR.join(''));
            }

            this._buttonItem = parent;
            this._deleteItem = target == 'li' ? parent.next() : gParent.find('[data-cbhelper=true]');
            this._deleteItem.data('customButton', this);

            if (this._delay) {
                clearTimeout(this._delay);
            }
            this._delay = setTimeout(function () {
                self._hideDelete();
            }, 6000);
        },

        //  type=modaldelete|modalconfirm
        _setModalConfirm: function (event, type) {
            var self = this;
            var parent = this.element.closest('ul').first();
            this._delay = false;

            if (parent.length === 0) {
                return;
            }
            var gParent = parent.parent();
            var aR = [];
            aR.push(
                "<ul class='list-inline list-unstyled pull-right' data-cbhelper='true'>",
                "<li>",
                "<a href='#' class='btn btn-default' data-cancel='true'>",
                "<i class='fa fa-ban fa-fw'></i>",
                "</a>",
                "</li>",
                "<li>",
                "<a href='#' class='btn " + (type == 'confirm' ? "btn-primary" : "btn-danger") + "' data-delete='true'>",
                "<i class='fa " + (type == 'confirm' ? "fa-check-square-o" : "fa-trash") + " fa-fw'></i>",
                "</a>",
                "</li>",
                "</ul>"
            );

            parent.addClass('hidden');
            gParent.append(aR.join(''));

            this._buttonItem = parent;
            this._deleteItem = gParent.find('[data-cbhelper=true]');
            this._deleteItem.data('customButton', this);

            if (this._delay) {
                clearTimeout(this._delay);
            }
            this._delay = setTimeout(function () {
                self._hideDelete();
            }, 6000);
        },

        //  type=set toggle
        _setToggle: function () {
            this.options.value = !this.element.hasClass('active');
            this.element.data('value', this.options.value);
            this.refresh();

            this._setCallback();
        },

        _setCallback: function () {
            if (this.options.lockfor > 0) {
                const lockedBtn = this.element;
                lockedBtn.addClass('locked');
                setTimeout(() => {
                    lockedBtn.removeClass('locked');
                }, this.options.lockfor);
            }

            me.setCallBackFromData(this.element, {
                e: this.element,
                value: this.options.value,
                tag: this.options.tag,
                parentid: this.options.parentid
            });
        }
    });


    /* ========================================================================
     *  public methods
     * ========================================================================
    */


    //  set button
    child.setButton = function (wireEvent, container) {
        var list = '';
        if (container !== null) {
            if (typeof container === 'string') {
                container = $(container);
            }
            list = container.find(ELEM);
        } else {
            list = $(ELEM);
        }

        $(list).button();
    }


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));